<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Genetic and Biochemical Test Results</h2>

        <div class="p-6">
            <h3 class="text-base md:text-2xl font-semibold mb-3">Genetic test results<sup>1</sup></h3>

            <ul class="list-disc pl-4  font-light">
                <li>
                    The patient and both parents received molecular genetic testing
                </li>
                <li>
                    Mutations in the <span class="italic">AGXT</span> gene were identified in the patient and his mother*
                </li>
            </ul>
        </div>

        <div class="overflow-x-auto">
            <table class="w-full border-collapse border-solid border-2 border-darkergrey break-words">
                <thead class="text-center text-white text-base md:text-lg">
                    <tr class="bg-lightblue">
                        <th class="p-3 border-solid border-2 border-darkergrey" rowspan="2">&nbsp;</th>
                        <th class="p-3 border-solid border-2 border-darkergrey" rowspan="2">Age, years</th>
                        <th class="p-3 border-solid border-2 border-darkergrey" colspan="2"><span class="italic">AGXT</span> gene</th>
                        <th class="p-3 border-solid border-2 border-darkergrey" rowspan="2">Kidney stones</th>
                        <th class="p-3 border-solid border-2 border-darkergrey" rowspan="2">Renal insufficiency</th>
                    </tr>
                    <tr class="bg-lightblue">
                        <th class="p-3 border-solid border-2 border-darkergrey min-w-44">Exon1/CDS1:c.120-121ins (p.Gly41Argfs*127)</th>
                        <th class="p-3 border-solid border-2 border-darkergrey min-w-44">Exon 4/CDS4:c.473C>T; (p.Ser158Leu)</th>
                    </tr>
                </thead>
    
                <tbody class="text-center  font-light text-sm md:text-base">
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Patient</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">33</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Farther</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">59</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">-</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">-</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">-</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">-</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Mother</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">57</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">+</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">-</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="bg-lightblue text-white p-6">
            <h3 class="text-base md:text-2xl font-semibold mb-3 text-white">Confirmation of PH1<sup>1</sup></h3>
            <ul class="list-disc pl-4 text-white font-light">
                <li class="text-white">
                    The patient was diagnosed with PH1 based on genetic testing and the findings of:
                    <ul class="list-inside list-['-_'] pl-6">
                        <li class="text-white">
                            Severely elevated plasma oxalate concentration
                            <ul class="list-inside list-['-_'] pl-6">
                                <li class="text-white">
                                    Pre-hemodialysis, 323 μmol/L; post-hemodialysis, 68.62 μmol/L
                                </li>
                            </ul>
                        </li>
                        <li class="text-white">
                            CaOx crystals in the kidney graft
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="p-6">
            <h3 class="text-base md:text-2xl font-semibold">OxalEurope and ERKNet recommended offering genetic counseling to patients with PH and their families<sup>2</sup></h3>
        </div>

        
    </div>
</template>
